import { render, staticRenderFns } from "./EventDescription.vue?vue&type=template&id=6950bbc2&scoped=true&"
import script from "./EventDescription.vue?vue&type=script&lang=js&"
export * from "./EventDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6950bbc2",
  null
  
)

export default component.exports